import React from "react";
import ListSubheader from "@material-ui/core/ListSubheader";
import styled from "styled-components";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";

const PaperContainer = styled(Paper)`
    width: 100%;
`;

const PaperListContainer = styled(List)`
    width: 100%;
`;

const DateHeader = styled(ListSubheader)`
  background-color: #E5F0EB;
  font-size: 1.10rem; 
  color: #046A38;
  margin-top: -8px;
`;


const CalendarGroupHeader = (props: any) => {
    const {children, className, style, ...moreProps} = props;
    return (
        <DateHeader
            {...moreProps}
            component={"div"}
        >{children}</DateHeader>
    );
};

export default CalendarGroupHeader;